import {z} from 'zod';

export const PkwEnvkvLegalApplicabilityStatusSchema = z.enum([
  'APPLICABLE',
  'NOT_APPLICABLE',
  'UNKNOWN',
]);
export type PkwEnvkvLegalApplicabilityStatus = z.infer<
  typeof PkwEnvkvLegalApplicabilityStatusSchema
>;

export const PkwEnvkvWorkflowStatusSchema = z.enum([
  'UNSUPPORTED_COUNTRY',
  'NOT_APPLICABLE',
  'APPLICABILITY_UNKNOWN',
  'MISSING_DATA',
  'READY_TO_CALCULATE',
  'CALCULATING',
  'CALCULATION_FAILED',
  'READY_TO_GENERATE',
  'GENERATING',
  'CURRENT',
  'OUTDATED',
  'GENERATION_FAILED',
]);
export type PkwEnvkvWorkflowStatus = z.infer<typeof PkwEnvkvWorkflowStatusSchema>;

export const PkwEnvkvAdvertisingStatusSchema = z.enum(['RED', 'YELLOW', 'GREEN']);
export type PkwEnvkvAdvertisingStatus = z.infer<typeof PkwEnvkvAdvertisingStatusSchema>;

// Set only while the workflow status is CALCULATION_FAILED or GENERATION_FAILED.
export const PkwEnvkvFailureReasonSchema = z.enum([
  'CALCULATION_DATA_UNAVAILABLE',
  'NOT_CONFIGURED',
  'UNSUPPORTED_INPUT',
  'DOCUMENT_SERVICE_UNAVAILABLE',
  'DOCUMENT_STORAGE_FAILED',
  'UNKNOWN',
]);
export type PkwEnvkvFailureReason = z.infer<typeof PkwEnvkvFailureReasonSchema>;

export const PkwEnvkvCalculationSchema = z.object({
  primaryCo2Class: z.string(),
  secondaryCo2Class: z.string().nullable(),
  co2LowCost: z.string(),
  co2MidCost: z.string(),
  co2HighCost: z.string(),
  co2LowBaseCost: z.string(),
  co2MidBaseCost: z.string(),
  co2HighBaseCost: z.string(),
  primaryFuelPrice: z.string(),
  primaryFuelBasePrice: z.string(),
  secondaryFuelPrice: z.string().nullable(),
  secondaryFuelBasePrice: z.string().nullable(),
  annualFuelCost: z.string().nullable(),
  averageAnnual: z.number().int(),
  fromYear: z.number().int(),
  toYear: z.number().int(),
  annualTax: z.string(),
});
export type PkwEnvkvCalculation = z.infer<typeof PkwEnvkvCalculationSchema>;

export const PkwEnvkvStatusResponseBodySchema = z.object({
  supported: z.boolean(),
  envkvRequired: z.boolean(),
  envkvRequiredReasonCodes: z.array(z.string()),
  legalApplicabilityStatus: PkwEnvkvLegalApplicabilityStatusSchema,
  legalReasonCodes: z.array(z.string()),
  workflowStatus: PkwEnvkvWorkflowStatusSchema,
  failureReason: PkwEnvkvFailureReasonSchema.nullable(),
  issues: z.array(z.string()),
  basicRuleSetVersion: z.string(),
  legalRuleSetVersion: z.string(),
  calculation: PkwEnvkvCalculationSchema.nullable(),
  documentFileId: z.string().uuid().nullable(),
  advertisingStatus: PkwEnvkvAdvertisingStatusSchema.nullable(),
  advertisingIssues: z.array(z.string()),
  // Server instants (RFC 3339 with fractional seconds). Older backends omit them,
  // so the whole card must keep working without any of the three.
  evaluatedAt: z.string().nullish(),
  calculationStartedAt: z.string().nullish(),
  documentStartedAt: z.string().nullish(),
});

export type PkwEnvkvStatusResponseBody = z.infer<typeof PkwEnvkvStatusResponseBodySchema>;

export type GetPkwEnvkvStatusApiArg = {
  vehicleId: string;
};

export type GetPkwEnvkvStatusApiResponse = PkwEnvkvStatusResponseBody;

export type CalculatePkwEnvkvApiArg = {
  vehicleId: string;
};

export type CalculatePkwEnvkvApiResponse = void;

export type GeneratePkwEnvkvDocumentApiArg = {
  vehicleId: string;
};

export type GeneratePkwEnvkvDocumentApiResponse = void;
